import { useLanguageContext } from "@/contexts/LanguageContext";
import { Colors } from "@/enums/Colors";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { useUpdateLanguage } from "@/hooks/queries/lazo-user/useLazoUserQueries";
import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonSwitch from "../utils/CommonSwitch";

export function LegacyLanguageSwitch() {
  const { language } = useLanguageContext();
  const loggedUser = AuthService.getUser();
  const updateLanguageMutation = useUpdateLanguage(loggedUser?.externalId || "");

  const [isChecked, setIsChecked] = useState(language === "en");

  useEffect(() => setIsChecked(language === "en"), [language]);

  function handleLanguageToggle(event: React.ChangeEvent<HTMLInputElement>) {
    const newCheckedState = event.target.checked;
    setIsChecked(newCheckedState);
    const newLanguage = newCheckedState ? "en" : "es";
    updateLanguageMutation.mutate(newLanguage);
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, position: "relative", zIndex: 10 }}>
      <Typography
        sx={{
          color: language === "es" ? Colors.WHITE : Colors.LIGHT_GRAY_BFC2C6,
          fontSize: "0.75rem",
          fontWeight: language === "es" ? 600 : 400,
          transition: "all 0.2s",
          userSelect: "none",
        }}
      >
        ES
      </Typography>
      <CommonSwitch
        checked={isChecked}
        onChange={handleLanguageToggle}
        inputProps={{ "aria-label": "Language toggle" }}
        sx={{
          width: "2rem",
          height: "1.25rem",
          "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: "0.0625rem",
            color: "#fff",
            "&.Mui-checked": {
              transform: "translateX(0.75rem)",
              color: "#fff",
            },
          },
          "& .MuiSwitch-thumb": {
            width: "1.125rem",
            height: "1.125rem",
          },
          "& .MuiSwitch-track": {
            backgroundColor: Colors.BUTTON_PURPLE,
            borderRadius: "0.625rem",
          },
          zIndex: 11,
        }}
      />
      <Typography
        sx={{
          color: language === "en" ? Colors.WHITE : Colors.LIGHT_GRAY_BFC2C6,
          fontSize: "0.75rem",
          fontWeight: language === "en" ? 600 : 400,
          transition: "all 0.2s",
          userSelect: "none",
        }}
      >
        EN
      </Typography>
      {updateLanguageMutation.isPending && (
        <CircularProgress
          size={12}
          sx={{
            color: Colors.WHITE,
            position: "absolute",
            left: "100%",
            top: "50%",
            transform: "translateY(-50%)",
            ml: 1,
          }}
        />
      )}
    </Box>
  );
}
